<div class="container">
  <div class="filter-container">
    <app-global-reporting-filters
      showModelOnly="false"
      [isSearchFilter]="showSearch"
      [exportColumns]="exportColumns"
      [exportKey]="exportKey"
      (isFilterValueChange)="toggleFilter($event)"
      (onGlobalFilterChange)="onSearch($event)"
      (onReloadGrid)="onReloadGrid()"
    ></app-global-reporting-filters>
  </div>
  <div class="grid-container">
    <app-reporting-grid-wrapper
      [page]="'industry'"
      [columns]="columns"
      [gridUrl]="gridUrl"
      [showGridFilters]="showGridFilters"
      [sortKey]="sortKey"
      [sortOrder]="'desc'"
      [(globalSearchVal)]="globalSearchVal"
      *ngIf="isDataSet"
    ></app-reporting-grid-wrapper>
  </div>
</div>
